import { BrowserCacheLocation, LogLevel } from "@azure/msal-browser";

// For MSAL.js 2.0 SPA apps, redirect URI must be the base URL (no /redirect path)
const getRedirectUri = () => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  
  // For localhost, always use window.location.origin (no env var needed)
  if (isLocalhost) {
    return window.location.origin;
  }
  
  // For production/container, use environment variable if set
  // IMPORTANT: VITE_REDIRECT_URI should be base URL only (e.g., https://stormhubchat-admin-app.azurewebsites.net)
  // DO NOT include /redirect path - MSAL.js handles redirects internally
  const envRedirectUri = import.meta.env.VITE_REDIRECT_URI;
  if (envRedirectUri) {
    return envRedirectUri.trim();
  }
  
  // Fallback to current origin
  return window.location.origin;
};

const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: import.meta.env.VITE_AZURE_AUTHORITY, 
    redirectUri: getRedirectUri(),
    // Ensure redirect URI is properly set for container environment
    postLogoutRedirectUri: getRedirectUri(),
    // Allow redirect URIs to match current origin
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage, 
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string) => {
        // Only log errors and warnings in production
        if (level === LogLevel.Error || level === LogLevel.Warning) {
          console.error(`MSAL ${level}:`, message);
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Verbose : LogLevel.Warning,
    },
    // Popup window configuration
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    allowNativeBroker: false,
    asyncPopups: false,
  },
};

export default msalConfig;
